module.exports = __webpack_public_path__ + "img/EsquemaSEN.16dd77af.jpeg";